import api from "@/api.js";
import moment from "moment";

export default {
  state: {
    siteData: {},
    fullLoading: false,
    dateRange: [],
    navigationDrawer: true,
    aGGridActionMenu: false,
    selectedRowData: {},
    appID: {},
    siteSettings: {},
    apiUrl: ""
  },
  mutations: {
    setSiteData(state, payload) {
      state.siteData = payload;
    },
    setFullLoader(state, loading) {
      state.fullLoading = loading;
    },
    setDateRange(state, date) {
      state.dateRange = date;
    },
    setNavigationDrawer(state, drawer) {
      state.navigationDrawer = drawer;
    },
    setAGGridActionMenu(state, payload) {
      state.aGGridActionMenu = payload;
    },
    setSelectedRowData(state, rowData) {
      state.selectedRowData = rowData;
    },
    setAppID(state, id) {
      state.appID = id;
    },
    setApiUrl(state, apiUrl) {
      state.apiUrl = apiUrl;
    }
  },
  actions: {
    async loadSiteData({ commit }) {
      let siteData = await api.get("applications/siteData");
      commit("setSiteData", siteData.data);
      document.title = siteData.data.name;
      let baseUrl = "https://api.flexi-comms.com";
      let host = window.location.host;
      if (
        host == "localhost:8080" ||
        host == "localhost:8081" ||
        host == "localhost:8082" ||
        host == "192.168.178.21:8080" ||
        host == "192.168.178.21:8081" ||
        host == "192.168.178.21:8082" ||
        host == "10.0.0.9:8080"
      ) {
        baseUrl = "http://localhost:32775";
      } else if (host == "flexicomms.firebaseapp.com") {
        baseUrl = "https://flexi-comms-api.simplesoft.nz";
      } else if (host.substring(0, 4) == "dev.") {
        baseUrl = "https://flexi-comms-api.simplesoft.nz";
      }
      commit("setApiUrl", baseUrl);
    },
    setFullLoaderState({ commit }, loading) {
      commit("setFullLoader", loading);
    },
    async loadDateRange({ commit }, payload) {
      commit("setDateRange", payload);
    },
    async loadDefaultDateRange({ commit }) {
      commit("setDateRange", [
        `${moment().format("YYYY-MM-DD")}`,
        `${moment()
          .day(-7)
          .format("YYYY-MM-DD")}`
      ]);
    },
    async setNavigationDrawerState({ commit }, payload) {
      commit("setNavigationDrawer", payload);
    },
    async setAGGridActionMenuState({ commit, state }, payload) {
      commit("setAGGridActionMenu", !state.aGGridActionMenu);
      commit("setSelectedRowData", payload);
    },
    async setSelectedRowData({ commit }, payload) {
      commit("setSelectedRowData", payload);
    },
    async getAppID({ commit }) {
      if (
        window.location.host == "flexicomms.firebaseapp.com" ||
        window.location.host == "localhost:8080" ||
        window.location.host == "192.168.178.21:8080"
      ) {
        commit("setAppID", 0);
      }
    },
    randomString({ commit }, payload) {
      var mask = "";
      if (payload.chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz";
      if (payload.chars.indexOf("A") > -1) mask += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      if (payload.chars.indexOf("#") > -1) mask += "0123456789";
      if (payload.chars.indexOf("!") > -1)
        mask += "~`!@#$%^&*()_+-={}[]:\";'<>?,./|\\";
      var result = "";
      for (var i = payload.len; i > 0; --i)
        result += mask[Math.floor(Math.random() * mask.length)];
      return result;
    }
  },
  getters: {
    siteData(state) {
      return state.siteData;
    },
    dateRange(state) {
      return state.dateRange;
    },
    fullLoading(state) {
      return state.fullLoading;
    },
    navigationDrawer(state) {
      return state.navigationDrawer;
    },
    aGGridActionMenu(state) {
      return state.aGGridActionMenu;
    },
    selectedRowData(state) {
      return state.selectedRowData;
    },
    apiUrl(state) {
      return state.apiUrl;
    }
  }
};
